/**
 * JS mirror of the CSS motion tokens in `styles/theme.css`.
 *
 * Durations here are in SECONDS (GSAP's unit); the CSS side (`--duration-*`) is
 * in ms — keep the two in sync. Easings are GSAP ease strings chosen to match the
 * CSS cubic-beziers in feel (out-eases for entrances, no elastic/bounce by default).
 */
export const DUR = {
  instant: 0.08,
  fast: 0.14,
  base: 0.22,
  slow: 0.32,
  reveal: 0.6,
} as const;

export const EASE = {
  /** general UI (≈ cubic-bezier(0.2,0,0,1)) */
  standard: 'power2.out',
  /** entrances — decelerate into place (≈ 0.22,1,0.36,1) */
  entrance: 'power3.out',
  /** exits — accelerate away */
  exit: 'power2.in',
  /** gentle overshoot — success confirmations only, used sparingly */
  emphasis: 'back.out(1.6)',
} as const;

/** Per-item stagger delays (seconds). */
export const STAGGER = {
  tight: 0.04,
  base: 0.07,
  loose: 0.1,
} as const;

export type EaseName = keyof typeof EASE;
